import { type UserAccountIsEditingAction } from 'src/types';

import { ApiActions } from '../constants/ApiActions';
import { UserAccountActions } from '../constants/UserAccount';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

export const IS_EDITING_KEY = 'isEditing';
export const ERROR_KEY = 'updateFail';
export const SUCCESS_KEY = 'updateSuccess';
export const DELETE_LISTENER_ERROR_KEY = 'deleteListenerFail';
export const DELETE_LISTENER_SUCCESS_KEY = 'deleteListenerSuccess';
export const LOG_OUT_ALL_DEVICES_ERROR_KEY = 'logOutAllDevicesFail';
export const LOG_OUT_ALL_DEVICES_SUCCESS_KEY = 'logOutAllDevicesSuccess';

const INITIAL_STATE = Map({
  [IS_EDITING_KEY]: false,
  [ERROR_KEY]: false as boolean | null,
  [SUCCESS_KEY]: false,
  [DELETE_LISTENER_ERROR_KEY]: false,
  [DELETE_LISTENER_SUCCESS_KEY]: false,
  [LOG_OUT_ALL_DEVICES_ERROR_KEY]: false,
  [LOG_OUT_ALL_DEVICES_SUCCESS_KEY]: false,
});
export type UserAccountState = typeof INITIAL_STATE;

// USERACCOUNT REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.UPDATE_ACCOUNT_SUCCESS]: updateAccountSuccess,
  [ApiActions.ACQUIRE_PRODUCT_SUCCESS]: updateAccountSuccess,
  [ApiActions.UPDATE_BILLING_INFO_V2_SUCCESS]: updateAccountSuccess,
  [ApiActions.FAMILY_PLAN_REMOVE_CHILD_SUCCESS]: updateAccountSuccess,
  [ApiActions.FAMILY_PLAN_EXIT_SUCCESS]: updateAccountSuccess,
  [ApiActions.UPDATE_ACCOUNT_FAIL]: updateAccountFail,
  [ApiActions.UPDATE_BILLING_INFO_V2_FAIL]: updateAccountFail,
  [UserAccountActions.USER_ACCOUNT_CLEAR_PASSWORD_FORM]: userAccountClearPasswordForm,
  [UserAccountActions.USER_ACCOUNT_CLEAR_SUCCESS_MESSAGE]: userAccountClearSuccessMessage,
  [ApiActions.DELETE_LISTENER_FAIL]: deleteListenerFail,
  [ApiActions.DELETE_LISTENER_SUCCESS]: deleteListenerSuccess,
  [UserAccountActions.CLEAR_DELETE_LISTENER_ERROR]: clearDeleteListenerError,
  [ApiActions.LOG_OUT_ALL_DEVICES_FAIL]: logOutAllDevicesFail,
  [ApiActions.LOG_OUT_ALL_DEVICES_SUCCESS]: logOutAllDevicesSuccess,
  [UserAccountActions.CLEAR_LOG_OUT_ALL_DEVICES_ERROR]: clearLogOutAllDevicesError,
  [UserAccountActions.RESET_LOG_OUT_ALL_DEVICES]: resetLogOutAllDevices,
  [UserAccountActions.USER_ACCOUNT_IS_EDITING]: userAccountIsEditing,
  [UserAccountActions.CLEAR_ERROR_KEY]: clearErrorKey,
});

// CASE FUNCTIONS

// modals are used to determine if an action was successful in order to call closeModal
function updateAccountSuccess(state: UserAccountState): UserAccountState {
  return state.set(SUCCESS_KEY, true);
}

function updateAccountFail(state: UserAccountState, action: $TSFixMe): UserAccountState {
  return state.set(ERROR_KEY, (action.error && action.error.errorType) || true);
}

function userAccountClearPasswordForm(state: UserAccountState): UserAccountState {
  return state.set(ERROR_KEY, null);
}

function userAccountClearSuccessMessage(state: UserAccountState): UserAccountState {
  return state.set(SUCCESS_KEY, false);
}

function deleteListenerFail(state: UserAccountState): UserAccountState {
  return state.set(DELETE_LISTENER_ERROR_KEY, true);
}

function deleteListenerSuccess(state: UserAccountState): UserAccountState {
  return state.merge({
    [DELETE_LISTENER_ERROR_KEY]: false,
    [DELETE_LISTENER_SUCCESS_KEY]: true,
  });
}

function clearDeleteListenerError(state: UserAccountState): UserAccountState {
  return state.set(DELETE_LISTENER_ERROR_KEY, false);
}

function logOutAllDevicesFail(state: UserAccountState): UserAccountState {
  return state.set(LOG_OUT_ALL_DEVICES_ERROR_KEY, true);
}

function logOutAllDevicesSuccess(state: UserAccountState): UserAccountState {
  return state.merge({
    [LOG_OUT_ALL_DEVICES_ERROR_KEY]: false,
    [LOG_OUT_ALL_DEVICES_SUCCESS_KEY]: true,
  });
}

function clearLogOutAllDevicesError(state: UserAccountState): UserAccountState {
  return state.set(LOG_OUT_ALL_DEVICES_ERROR_KEY, false);
}

function resetLogOutAllDevices(state: UserAccountState): UserAccountState {
  return state.merge({
    [LOG_OUT_ALL_DEVICES_ERROR_KEY]: false,
    [LOG_OUT_ALL_DEVICES_SUCCESS_KEY]: false,
  });
}
function userAccountIsEditing(
  state: UserAccountState,
  { payload }: UserAccountIsEditingAction,
): UserAccountState {
  return state.set(IS_EDITING_KEY, payload.isEditing);
}

function clearErrorKey(state: UserAccountState): UserAccountState {
  return state.set(ERROR_KEY, false);
}
